import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Profile, profileFromDto } from '@/app/entities/profile';

import { ProfileResponseDto } from './dto';

import { getApiEndpoint } from '@/app/core/http';
import { ApiResponse, mapDataNonNull, ApiResponseNonNull } from '@/app/shared/http';

@Injectable({
  providedIn: 'root',
})
export class ProfileApi {
  private readonly http = inject(HttpClient);

  getProfile(): Observable<ApiResponseNonNull<Profile>> {
    return this.http
      .get<ApiResponse<ProfileResponseDto>>(getApiEndpoint('profile.details'))
      .pipe(mapDataNonNull((data) => profileFromDto(data.user)));
  }
}
